import { useMemo } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import AdminSidebar from '../components/AdminSidebar';
import BreadcrumbBar from '../components/BreadcrumbBar';
import WorkspaceFrame from '../components/WorkspaceFrame';
import { useSupabaseAuth } from '../context/AuthContext';

const PAGE_TITLES = {
  '/admin': 'Admin home',
  '/admin/users': 'Users & roles',
  '/admin/taxonomy': 'Process taxonomy',
  '/admin/gate-templates': 'Gate deliverable templates',
  '/admin/role-assignments': 'Role assignments',
  '/admin/estimation-defaults': 'Estimation defaults',
  '/admin/cost-types': 'Cost types',
  '/admin/role-types': 'Role types',
  '/admin/functional-spec-sections': 'Functional spec sections',
};

export default function AdminShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile } = useSupabaseAuth();
  const pageTitle = PAGE_TITLES[location.pathname] || 'Admin';

  const segments = useMemo(() => {
    if (location.pathname === '/admin') {
      return [{ label: 'Admin', current: true }];
    }
    return [
      { label: 'Admin', onClick: () => navigate('/admin') },
      { label: pageTitle, current: true },
    ];
  }, [location.pathname, navigate, pageTitle]);

  return (
    <div className="screen active">
      <AdminSidebar />
      <div className="main">
        <BreadcrumbBar segments={segments} />
        <WorkspaceFrame rexBase={{ layer: 'admin', orgName: profile?.organisation_name || 'Admin' }}>
          <Outlet />
        </WorkspaceFrame>
      </div>
    </div>
  );
}
